// extracted by mini-css-extract-plugin
export default {"segment-rule-desc-wrapper":"segment-rule-desc-wrapper_CsFzZ"};